import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { ListSubheader } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from "react-router";
import { useEffect } from 'react';

const StyledListHeader = styled(ListSubheader)({
  backgroundImage: 'var(--Paper-overlay)',
});

export default function MenuAppBar() {
  const [auth, setAuth] = React.useState(false);

  let navigate = useNavigate();

  useEffect(() => {
    fetch('/api/loggedIn')
        .then(res => res.json())
        .then(r => {
            setAuth(r);
        })
        .catch(e => console.error(e));
  }, [navigate]);

  

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
      {!!auth && <ToolbarLoggedIn auth={auth} setAuth={setAuth} navigate={navigate} />}
      {!auth && <ToolbarNotLoggedIn/>}
      </AppBar>
      <Toolbar/>
    </Box>
  );
}

function ToolbarNotLoggedIn(props) {
  return(
    <Toolbar>
      <a href="/">
        <img src='/logo_transparent.png' style={{maxWidth: '70px', margin: '7px'}} alt='logo of Fritti Wiki'/>
      </a>
      <Typography variant="h6" component="a" sx={{ flexGrow: 1 }}>
        Fritti Wiki
      </Typography>
      <Typography variant="h6" component="a" href="/login" sx={{ flexGrow: 1 }}>
        Login / Registrieren
      </Typography>
    </Toolbar>
  );
}

function ToolbarLoggedIn(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [userAnchorEl, setUserAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenu = (event) => {
    setUserAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
    const logout = () => {
    const requestOptions = {
        method: "POST",
        redirect: "follow"
        };
    fetch("api/perform_logout", requestOptions)
    .then(r => {
      console.info("Logout");
    }).catch(e => {
      console.error("Problem mit Logout"+e);
    }).finally(() => {
      props.setAuth(false);
      props.navigate("/login");
    })
  };
    return (
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            aria-controls={open ? 'grouped-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleMenu}
          >
            <MenuIcon />
          </IconButton>
            <Menu
              id="grouped-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              slotProps={{
                list: {
                  'aria-labelledby': 'basic-button',
                  sx: {
                    py: 0,
                  },
                },
              }}
            >
            <StyledListHeader>Allgemein</StyledListHeader>
            <MenuItem  component={"a"} href={'/product'} onClick={props.handleClose}>Produkte</MenuItem>
            <MenuItem  component={"a"} href={'/fryer'} onClick={props.handleClose}>Fryer</MenuItem>
            <MenuItem  component={"a"} href={'/impressum'} onClick={props.handleClose}>Impressum</MenuItem>
            {false && <StyledListHeader>Admin</StyledListHeader>}
          </Menu>
          <a href="/">
            <img href="/" src='/logo_transparent.png' style={{maxWidth: '70px', margin: '7px'}} alt='Logo of Fritti Wiki'/>
          </a>
          <Typography variant="h6" component="a" sx={{ flexGrow: 1 }}>
            Fritti Wiki
          </Typography>
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleUserMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={userAnchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                open={Boolean(userAnchorEl)}
                onClose={() => setUserAnchorEl(null)}
              >
                <MenuItem component={"a"} href={'/user'} onClick={() => setUserAnchorEl(null)}>Profil</MenuItem>
                <MenuItem component={"a"} href={'/report'} onClick={() => setUserAnchorEl(null)}>Erfahrungsberichte</MenuItem>
                <MenuItem onClick={logout}>Logout</MenuItem>
              </Menu>
            </div>
        </Toolbar>
      );
  }